import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
    uptoken: '',
    currentIndex: [],
    categoryArr: [],
    topicArr: [],
    productArr: [],
    localBanner: []
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
    SETTOKEN(state, token) {
        state.uptoken = token
    },
    SETCURRENTINDEX(state, val) {
        state.currentIndex = val
    },
    SETTOPICARR(state, val) {
        state.topicArr = val
    },
    SETCATEGORYARR(state, val) {
        state.categoryArr = val
    },
    SETPRODUCTARR(state, val) {
        state.productArr = val
    },
    SETLOCALBANNER(state, val) {
        state.localBanner.push(val)
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js